module.exports = __webpack_public_path__ + "static/media/logo-university-of-waterloo.30671978.png";